<template>
    <div />
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
    name: 'Profile',
})
</script>
